import React from "react";

/**
 * Non-blocking progress chip.
 * `steps` = array of { key, label, complete: bool, href?: string }
 * Displays "X% · N of M complete · missing item" hint.
 */
export const SetupProgress = ({ steps, testid = "setup-progress" }) => {
  const complete = steps.filter((s) => s.complete).length;
  const total = steps.length;
  const pct = total === 0 ? 0 : Math.round((complete / total) * 100);
  const nextMissing = steps.find((s) => !s.complete);

  return (
    <div
      data-testid={testid}
      className="inline-flex items-center gap-2 border border-coach-silver bg-white rounded-sm px-2.5 py-1 text-[11px]"
      title={steps
        .map((s) => `${s.complete ? "✓" : "•"} ${s.label}`)
        .join("\n")}
    >
      <span
        data-testid={`${testid}-percent`}
        className="font-semibold text-coach-blue"
      >
        {pct}%
      </span>
      <span className="text-steel">
        {complete}/{total} complete
      </span>
      {nextMissing && (
        <>
          <span className="text-steel/40">·</span>
          {nextMissing.href ? (
            <a
              href={nextMissing.href}
              data-testid={`${testid}-next`}
              className="text-coach-blue hover:underline"
            >
              Add {nextMissing.label}
            </a>
          ) : (
            <span
              data-testid={`${testid}-next`}
              className="text-steel"
            >
              Next: {nextMissing.label}
            </span>
          )}
        </>
      )}
      <span
        className="ml-1 flex gap-0.5"
        aria-hidden="true"
      >
        {steps.map((s) => (
          <span
            key={s.key}
            className="w-1.5 h-1.5 rounded-full inline-block"
            style={{
              background: s.complete
                ? "var(--brand-lime, #B7E31D)"
                : "var(--fg-muted, #6B747C)",
              opacity: s.complete ? 1 : 0.35,
            }}
            title={`${s.complete ? "✓" : "•"} ${s.label}`}
          />
        ))}
      </span>
    </div>
  );
};
